import {Layout} from 'antd'
import NavHeader from '../../../components/NavHeader'
import SiderMenuMain from '../../../components/SiderMenuMain'
import NavFooter from '../../../components/NavFooter'

const {Content} = Layout

type IProps = {children?: React.ReactNode}

export default function DigitalAssessLayout({children}: IProps) {
  return (
    <Layout>
      <NavHeader />
      <Content className={'main-body'}>
        <Layout>
          <SiderMenuMain />
          <Content className={'main-content'}>{children}</Content>
        </Layout>
      </Content>
      <NavFooter />
    </Layout>
  )
}
